export enum DialogMode {
    Add, Edit
}


export function awaitFor(ms:number):Promise<void> {
    return new Promise<void>((resolve, reject) => { setTimeout(() => { resolve(); }, ms) });
}